import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { SocketService, SocketMessageFE, ProcessType, SocketLog, PrintJsonMessage } from 'app/services/socket.service';
import { SocketProcess, CommonSocketMsgComponent } from 'app/components/common-socket-msg/common-socket-msg.component';
import { CancelTranscService } from 'app/services/cancel-transc.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { LongTransaction } from 'app/components/feat-transaction-log/feat-transaction-log.component';

@Injectable({
  providedIn: 'root'
})
export class TransactionLogService {
  public socketProcesses: BehaviorSubject<Array<LongTransaction>> = new BehaviorSubject([]);
  public statusMessage = new BehaviorSubject('init message');

  constructor(
    private cancelService: CancelTranscService,
  ) {

   }

	public cancelProcess(processId) {
		const process = this.socketProcesses.value.find((p) => p.id === processId);
		// Cancel the process
		this.cancelService.cancelTransc(processId, () => {
			// Update process type as canceling
			// This should be set after cancelTransc is successfully called.
      if (process.status !== 'Completed' || 'Error') { // if process already finished, do not update status
        process.status = 'Canceling';
				const filtered = this.socketProcesses.value.filter((t) => t.id !== process.id)
        this.socketProcesses.next(filtered.concat(process));
			}
		});
  }
}
